import RequestAbstract from "../abstract";

export default class PaymentRefunds extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payment-refunds";
    }

}
